import { Header2 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { FC } from 'react';

import { InfoMinPriceProps } from './types';

import styles from './InfoMinPrice.css';

export const InfoMinPrice: FC<InfoMinPriceProps> = props => {
  const { minPrice } = props;

  return (
    <div className={styles['contaner']}>
      <Header2>{`от ${numberToPrettyString(minPrice)} ₽/мес. за рабочее место`}</Header2>
    </div>
  );
};

InfoMinPrice.displayName = 'InfoMinPrice';
